import { useEffect, useState } from 'react';

/** Subscribe to a CSS media query. SSR-safe initial value uses `false` if window is missing. */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false,
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const sync = () => setMatches(mql.matches);
    sync();
    mql.addEventListener('change', sync);
    return () => mql.removeEventListener('change', sync);
  }, [query]);

  return matches;
}

/** Tailwind `sm` breakpoint: below this is phone chrome (bottom tabs, etc.). */
export function useIsCompact(): boolean {
  return useMediaQuery('(max-width: 639px)');
}
